import logo from './logo.svg';
import './App.css';
import Task from './Input.js'
import Add from './Add.js'
import { useState } from 'react'

function App() {
     const [item, setItem] = useState([
       {id: 1, name: "Add new task", time: new Date().toLocaleTimeString()}
       ])
       
  return (
    <>
    <h1 style = {
      {textAlign: "center"}
    }>ToDo App</h1>
    <Add item={item} setItem={setItem}/>
    <Task item={item} setItem={setItem}/>
    </>
  );
}

export default App;
